<administrasjon-navigasjon aktiv="asynkOppgaver">

<div class="velg-visning">
  <label for="statusfilter">{{ 'Vis' | translate }}</label>
  <select id="statusfilter" [value]="aktivtFilter()" (change)="filterEndret(+$any($event.target).value)">
    @for (status of statuser; track status) {
      <option [value]="status">{{ statusTekst(status) }}</option>
    }
  </select>
  <span class="nedtonet">
    {{ 'Viser {antall} jobber med status «{status}»' | translate:{antall: oppgaver().length, status: statusTekst(aktivtFilter())} }}
  </span>
</div>

@if (oppgaver().length > 0) {
  <div class="liste">
    @for (oppgave of oppgaver(); track oppgave.id) {
      <article class="liste-rad">
        <div class="tidspunkt">
          <span class="ikon ion-ios-clock-outline" aria-hidden="true"></span>
          <strong>{{ oppgave.statusSistEndretDato | zoneddatetime:'short' }}</strong>
        </div>
        <div class="detaljer">
          <div>{{ oppgave.id }}</div>
          <table>
            <tr>
              <th>{{ 'Type' | translate }}:</th>
              <td>{{ oppgave.type }}</td>
            </tr>
            <tr>
              <th>{{ 'Status' | translate }}:</th>
              <td>{{ statusTekst(oppgave.status) }}</td>
            </tr>
            @for (innslag of (oppgave.konfigurasjon | keyvalue); track innslag.key) {
              <tr>
                <th>{{ innslag.key }}:</th>
                <td>{{ innslag.value }}</td>
              </tr>
            }
          </table>
        </div>
        <div class="handlinger">
          <button type="button" [disabled]="!oppgave.kanRestartes" (click)="kjorIgjen(oppgave)">{{ 'Kjør på nytt' | translate }}</button>
          <button type="button" [disabled]="!oppgave.kanParkeres" (click)="parker(oppgave)">{{ 'Parker' | translate }}</button>
        </div>
      </article>
    }
  </div>
}
</administrasjon-navigasjon>
